import { cn } from '@/lib/utils'
import styles from './PriorityServicesBadge.module.css'

export type PriorityServicesBadgeSize = 'sm' | 'md' | 'header'

type PriorityServicesBadgeProps = {
  size?: PriorityServicesBadgeSize
  className?: string
}

export default function PriorityServicesBadge({
  size = 'md',
  className,
}: PriorityServicesBadgeProps) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/images/logo_priority.svg"
      alt="Priority Services"
      width={176}
      height={64}
      data-size={size}
      className={cn(styles.badge, className)}
    />
  )
}
